/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
/**
 * key: from.name
 * value: to.name
 */
const routerToClear = {
  "Login": "Login",
  "home": "home",
  "MaterialManage":"MaterialManage"
}
export default routerToClear



// WEBPACK FOOTER //
// ./src/assets/utils/session-conf.js